import * as yup from 'yup'

export const createGroupSchema = yup.object().shape({
    type: yup.string().required('Выберите тип приглашения'),
    group_id: yup.string().required('Выберите группу'),
    permanent: yup.boolean()
})